import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";
import { CURRENCY_SYMBOL } from "utils/constants";
import CustomModal from "../CustomModal";

const Cart = ({ open, setOpen, modules = [], onEdit, generalCost }) => {
  const { t } = useTranslation(NAME_SPACES.PUBLIC.PROCESSES);
  const TRANSLATION = t("B2C_LMF.CART", { returnObjects: true });
  return (
    <CustomModal
      open={open}
      setOpen={setOpen}
      width={600}
      title={TRANSLATION.TITLE}
      closeText={TRANSLATION.CLOSE}
      confirmText={TRANSLATION.EDIT}
      onSubmit={() => {
        onEdit();
        setOpen(false);
      }}
    >
      <div className="lmf__cart">
        <div className="lmf__cart--product">
          <span className="lmf__cart--product--name">
            {get(generalCost, "insurancePlan.name")}
          </span>
          <span className="lmf__cart--product--price">
            <span className="price">
              {modules
                .reduce(
                  (acc, { cost }) => (acc += cost),
                  get(generalCost, "cost", 0)
                )
                .toFixed(2)}{" "}
              {CURRENCY_SYMBOL[generalCost?.currency]}
            </span>
            <small className="frequency">{TRANSLATION.PER_MONTH}</small>
          </span>
        </div>
        <div className="lmf__cart--detail">
          <span className="lmf__cart--title">
            {TRANSLATION.OFFER_INCLUDED}
          </span>
          <div className="lmf__cart--prices">
            <div className="lmf__cart--prices--item">
              <span>{get(generalCost, "insurancePlan.name")}</span>
              <span>
                {get(generalCost, "cost")}
                {CURRENCY_SYMBOL[generalCost?.currency]}
              </span>
            </div>
            {modules.map((module, index) => (
              <div key={`modules-${index}`} className="lmf__cart--prices--item">
                <span>{get(module, "insurancePlan.name")}</span>
                <span>
                  {get(module, "cost")}
                  {CURRENCY_SYMBOL[module?.currency]}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </CustomModal>
  );
};

export default Cart;
